import "freespace-react-components/style.css"
import { AdminNavigation, Tooltip } from "freespace-react-components";


import DeviceIcon from "./assets/images/SVGComponents/DeviceIcon";
import { useEffect, useState } from "react";


export default function Root() {


  const authKey = window.localStorage.getItem("spaceio-key");
  let userAccountInfo = null;
  const [accountName,setAccountName] =  useState('');
  const [pathname, setPathname] = useState(window.location.pathname.replace("/global/", ""));

useEffect(() => {
  const handleLocationChange = () => {
    setPathname(window.location.pathname.replace("/global/", ""));
  };

  window.addEventListener('popstate', handleLocationChange);
  return () => {
    window.removeEventListener('popstate', handleLocationChange);
  };
}, []);

useEffect(() => {

  const userAccountInfoString = localStorage.getItem('spaceio-user');
  const userAccountInfo = JSON.parse(userAccountInfoString);

  if (pathname === 'health-overview') {
    setAccountName('All Accounts');
  } else {
    setAccountName(userAccountInfo ? userAccountInfo.account.name : '');
  }
}, [authKey, pathname]); 
  

  const navigationObjectLocal = [
    {
      label: <span style={{ fontWeight: 'bold', color: 'grey' }}>Dashboard</span>,
      items: [
        { label: 'Health Overview', icon: <i className='pi pi-circle text-white ' style={{ fontSize: '8px' }} ></i>, path: 'global/health-overview' },
      ]
    }
  ]


  const globalNavigationObjectLocal = {
    'deviceHealthOverview': {
      name: 'Device Health Overview',
      path: '/global/health-overview',
      icon: <div className='flex justify-center item-center w-full'>
        <span className="nhp text-center p-2">
          <DeviceIcon />
        </span>
        <Tooltip
          position={'top'}
          event={'hover'}
          disabled={false} target={'.nhp'}
          children={<p className='text-xs p-0.5'>Devices</p>}
        />
      </div>

    },
  }

  return (
    <AdminNavigation
      options={navigationObjectLocal}
      navColor={'bg-primaryText'}
      accountIcon={userAccountInfo ? userAccountInfo.account.logoUrl : ''}
      accountName={accountName}
      controlMenu={<>
        <img
          className='w-10 h-10 rounded-full cursor-pointer'
          src='https://cdn.afreespace.com/profile-images/DK968335213.png'
          alt='acountIcon'
        />
        <img className='w-5 h-5 rounded-full cursor-pointer' alt='SettingIcon'></img>
        <img className='w-5 h-5 rounded-full cursor-pointer' alt='SettingIcon'></img>
        <img className='w-5 h-5 rounded-full cursor-pointer' alt='SettingIcon'></img>
      </>}
      globalNavigationObject={globalNavigationObjectLocal}
    />
  );
}